import { SvrConn } from "../utils/axios/index";
/**
 * Metodo que consulta los servicios
 */
const getServicios = async () => {
  let res = {};
  try {
    res = await SvrConn.post("/api/service/getservicio");
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 * 
 */
const getServicioAll = async () => {
  let res = {};
  try {
    res = await SvrConn.get("/api/service/getservicioall");
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 *  Buscar Los servicios por area sin importar el estado
 */
const getServicioAllxArea = async (AreaId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/service/getservicioallarea",{AreaId});
  } catch (Error) {
    res = Error;
  }
  return res;
};

/**
 * Solitar turno para el servicio
 */
const getSolicitarTurno = async (AreaId, ServicioId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/turno/getsolitarturno", {
      AreaId,
      ServicioId,
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 *
 */
const getServiciosPend = async () => {
  let res = {};
  try {
    res = await SvrConn.post("/api/turno/getserviciopend");
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 * Llama el turno pendiente seleccionado, desde el modulo de turnos pendientes.
 */
const getSolicitarTurnPend = async (PeriodoId, TurnoId, ItemId, AreaId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/turno/getsolicitarturnpend", {
      PeriodoId,
      TurnoId,
      ItemId,
      AreaId,
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 *
 */
/**
 * Solitar turno para el servicio
 */
const getServicioInt = async (AreaId, ServicioId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/service/getservicioint", {
      AreaId,
      ServicioId,
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 * metodo para actualizar servicios
 */
const ActualizaServicio = async (data) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/service/setactualizaservicio", data);
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 * 
*/
const setBloqueaServicio = async (areaId, servicioId, TagId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/service/setbloqueaservicio", { areaId, servicioId,TagId });
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
* 
 */
const getServicioProceso = async (TurnoId, ModuloId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/turno/getservicioproceso", {
      TurnoId,
      ModuloId,
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};
//------
const getServiciosmedPend = async () => {
  let res = {};
  try {
    res = await SvrConn.post("/api/turno/getserviciomedpend");
  } catch (Error) {
    res = Error;
  }
  return res;
};


export {
  getServicios,
  getServiciosPend,
  getSolicitarTurno,
  getSolicitarTurnPend,
  getServicioAll,
  getServicioAllxArea,
  getServicioInt,
  ActualizaServicio,
  setBloqueaServicio,
  getServicioProceso,
  getServiciosmedPend
};
